
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"
import { Toggle } from "@/components/ui/toggle"

export function ThemeToggle() {
  const { setTheme, theme } = useTheme()

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light")
  }

  return (
    <Toggle 
      aria-label="Toggle theme" 
      pressed={theme === "dark"}
      onPressedChange={toggleTheme}
      className={`px-2 ${theme === "dark" 
        ? "border-futuristic-border text-blog-neon bg-futuristic-bg-dark/60 hover:bg-blog-neon/10" 
        : "border-gray-200 bg-white/80 hover:bg-gray-100/80"}`}
    >
      {theme === "dark" ? (
        <Moon className="h-4 w-4 text-blog-neon" />
      ) : (
        <Sun className="h-4 w-4 text-amber-500" />
      )}
    </Toggle>
  )
}
